import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Checkbox } from "@/components/ui/checkbox";
import { Tag, Plus } from "lucide-react";

// Small colored chip for a single tag
export const TagChip = ({ tag, onRemove }) => (
  <span
    data-testid={`tag-chip-${tag.id}`}
    className="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[0.7rem] font-semibold"
    style={{ backgroundColor: `${tag.color}1a`, color: tag.color, border: `1px solid ${tag.color}55` }}
  >
    {tag.label}
    {onRemove && (
      <button
        type="button"
        data-testid={`tag-remove-${tag.id}`}
        onClick={(e) => { e.stopPropagation(); onRemove(tag.id); }}
        className="ml-0.5 leading-none opacity-70 hover:opacity-100"
        aria-label={`Remove ${tag.label}`}
      >
        ×
      </button>
    )}
  </span>
);

// Popover to toggle which library tags apply to a record
export const TagPicker = ({ library, selected, onToggle, triggerTestId = "tag-picker-trigger" }) => (
  <Popover>
    <PopoverTrigger asChild>
      <button
        type="button"
        data-testid={triggerTestId}
        onClick={(e) => e.stopPropagation()}
        className="inline-flex items-center gap-1 rounded-full border border-dashed border-border px-2 py-0.5 text-[0.7rem] font-semibold text-muted-foreground hover:border-primary hover:text-primary transition-colors"
      >
        <Plus className="h-3 w-3" /> Tag
      </button>
    </PopoverTrigger>
    <PopoverContent align="start" className="w-56 p-2" onClick={(e) => e.stopPropagation()}>
      <div className="flex items-center gap-1.5 px-1 pb-2 text-xs font-semibold text-muted-foreground">
        <Tag className="h-3.5 w-3.5" /> Apply tags
      </div>
      {library.length === 0 ? (
        <p className="px-1 pb-1 text-xs text-muted-foreground">No tags yet. Create some in Manage Tags.</p>
      ) : (
        <div className="max-h-56 overflow-auto space-y-0.5">
          {library.map((t) => (
            <label
              key={t.id}
              data-testid={`tag-option-${t.id}`}
              className="flex items-center gap-2 rounded-md px-1.5 py-1.5 hover:bg-muted cursor-pointer"
            >
              <Checkbox
                checked={selected.includes(t.id)}
                onCheckedChange={() => onToggle(t.id)}
                data-testid={`tag-checkbox-${t.id}`}
              />
              <span className="h-2.5 w-2.5 rounded-full shrink-0" style={{ backgroundColor: t.color }} />
              <span className="text-sm truncate">{t.label}</span>
            </label>
          ))}
        </div>
      )}
    </PopoverContent>
  </Popover>
);
